module.exports = __webpack_public_path__ + "img/permission-icon-9.f5f1342d.jpg";